import React from "react";
import Calendar from "@/pages/admin/Calendar";

export default function TrainerCalendar() {
  return <Calendar role="trainer" />;
}
